export const SERVER_ENDPOINT =
  process.env.REACT_APP_NODE_ENV === "production"
    ? process.env.REACT_APP_LIVE_SERVER_URL
    : process.env.REACT_APP_LOCALHOST_URL;

export const SITE_URL =
  process.env.REACT_APP_NODE_ENV === "production"
    ? process.env.REACT_APP_LIVE_URL
    : process.env.REACT_APP_LOCAL_URL;

export enum NOTIFICATION_TYPES {
  LIKE = 1,
}
